import { Box, Typography, styled } from "@mui/material";

const BlackBorderBox = styled(Box)(() => ({
    border: "3px solid navy",
    borderRadius: "20px",
    padding: "15px",
    height: "170px",
    width: "170px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    textAlign: "center",
    "& .MuiTypography-root": {
        fontSize: "0.8rem",
        marginTop: "-15px",
    },
}));

export function Educationpage() {
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "8vw",
                    marginTop: "3vw",
                }}
            >
                <Typography style={{ fontSize: "2rem", fontWeight: "bold" }}>
                    EDUKASI APA YANG KAMU CARI?
                </Typography>
            </div>

            <div
                style={{
                    marginLeft: "15vw",
                    marginRight: "15vw",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        paddingTop: "4vw",
                        marginBottom: "11vw",
                        rowGap: "30px",
                        columnGap: "30px",
                    }}
                >
                    <BlackBorderBox>
                        <a href="/assets/docs/stop-babs.pdf" target="_blank">
                            <img
                                src="/assets/icon-education/babs.webp"
                                alt="Stop Buang Air Besar Sembarangan"
                                style={{
                                    maxWidth: "130px",
                                    marginBottom: "20px",
                                }}
                            ></img>
                            <Typography>
                                Stop Buang Air Besar Sembarangan
                            </Typography>
                        </a>
                    </BlackBorderBox>
                    <BlackBorderBox>
                        <a
                            href="/assets/docs/urgensi-penyedotan-tangki.pdf"
                            target="_blank"
                        >
                            <img
                                src="/assets/icon-education/menjaga-lingkungan.webp"
                                alt="Kenapa Tangki Septik Perlu Disedot?"
                                style={{
                                    maxWidth: "130px",
                                }}
                            ></img>
                            <Typography>
                                Kenapa Tangki Septik Perlu Disedot?
                            </Typography>
                        </a>
                    </BlackBorderBox>
                    <BlackBorderBox>
                        <a
                            href="/assets/docs/tata-cara-penggunaan-mck.pdf"
                            target="_blank"
                        >
                            <img
                                src="/assets/icon-education/mck-sehat-dan-bersih.webp"
                                alt="Tata Cara Penggunaan MCK"
                                style={{
                                    maxWidth: "130px",
                                }}
                            ></img>
                            <Typography>Tata Cara Penggunaan MCK</Typography>
                        </a>
                    </BlackBorderBox>
                    <BlackBorderBox>
                        <a
                            href="/assets/docs/tata-cara-merawat-mck.pdf"
                            target="_blank"
                        >
                            <img
                                src="/assets/icon-education/tata-cara-perawatan.webp"
                                alt="Tata Cara Perawatan Tangki Septik"
                                style={{
                                    maxWidth: "130px",
                                }}
                            ></img>
                            <Typography>Tata Cara Perawatan MCK</Typography>
                        </a>
                    </BlackBorderBox>
                    <BlackBorderBox>
                        <a
                            href="/assets/docs/tata-cara-penyedotan-tangki-septik.pdf"
                            target="_blank"
                        >
                            <img
                                src="/assets/icon-education/tata-cara-penyedotan.webp"
                                alt="Tata Cara Pengurasan Tangki Septik"
                                style={{
                                    maxWidth: "130px",
                                }}
                            ></img>
                            <Typography>
                                Tata Cara Pengurasan Tangki Septik
                            </Typography>
                        </a>
                    </BlackBorderBox>
                    <BlackBorderBox>
                        <a
                            href="/assets/docs/tangki-septik-sni.pdf"
                            target="_blank"
                        >
                            <img
                                src="/assets/icon-education/tangki-septik-sni.webp"
                                alt="Tangki Septik Sesuai Standar SNI"
                                style={{
                                    maxWidth: "130px",
                                }}
                            ></img>
                            <Typography>
                                Tangki Septik Sesuai Standar SNI
                            </Typography>
                        </a>
                    </BlackBorderBox>
                </div>
            </div>
        </div>
    );
}
